import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEagleComponent } from './simple-icons-eagle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEagleComponent ],
    exports:      [ SimpleIconsEagleComponent ],
    bootstrap:    []
})
export class SimpleIconsEagleModule {}
